// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabs li[aria-selected="true"] {
  color: #0b2d71 !important;
  font-weight: 600;
  border: 4px solid #fff;
  border-width: 0 0 4px;
  border-bottom: #0b2d71 4px solid;
}

.breadcrumb-nav {
  padding: 8px 16px 6px;
}

.breadcrumb-nav .breadcrumb {
  padding-bottom: 0;
  margin-bottom: 0;
}

div.tabbed > ul.tabs {
  margin: 0;
  padding: 0;
  text-align: left;
}

.breadcrumb-link {
  color: #0b2d71;
  cursor: pointer;
  text-decoration: underline;
}

.search-icon {
  font-size: 16px;
  line-height: 16px;
  width: 16px;
  height: 16px;
}`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/projects-dashboard/create-new-project-dialog/create-new-project-dialog.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd","sourcesContent":[".tabs li[aria-selected=\"true\"] {\n  color: #0b2d71 !important;\n  font-weight: 600;\n  border: 4px solid #fff;\n  border-width: 0 0 4px;\n  border-bottom: #0b2d71 4px solid;\n}\n\n.breadcrumb-nav {\n  padding: 8px 16px 6px;\n}\n\n.breadcrumb-nav .breadcrumb {\n  padding-bottom: 0;\n  margin-bottom: 0;\n}\n\ndiv.tabbed > ul.tabs {\n  margin: 0;\n  padding: 0;\n  text-align: left;\n}\n\n.breadcrumb-link {\n  color: #0b2d71;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.search-icon {\n  font-size: 16px;\n  line-height: 16px;\n  width: 16px;\n  height: 16px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
